import { To, Location } from 'react-router-dom';

import { organizationHeader, organizationQueryKey } from '@cast/constants';
import { client } from '@cast/core';
import { Organization } from '@cast/types';

import { getUser } from '@cast/infrastructure-auth';
import {
  getLocationDescriptor,
  GetLocationDescriptorSettings,
} from '@cast/utils';

import { Member } from '@cast/features-organization-shared-types';

export const DEFAULT_ORGANIZATION_NAME = 'My Organization';

export const isDefaultOrganizationName = (name?: string): boolean =>
  !name?.trim() || name.trim() === DEFAULT_ORGANIZATION_NAME;

export const setOrgIdToBrowserStorages = (orgId: string): void => {
  client.defaults.headers.common[organizationHeader] = orgId;
  sessionStorage.setItem(organizationQueryKey, orgId);
  localStorage.setItem(organizationQueryKey, orgId);
};

export const addOrgIdToLocation = (
  organizationId: Organization['id'] | undefined,
  settings: {
    path: To | undefined;
    location: Location;
    locationSettings?: GetLocationDescriptorSettings;
    openInNewTab?: boolean;
  }
): Partial<Location> | string | undefined => {
  if (!settings.path) {
    return settings.path;
  }
  const newDestination = getLocationDescriptor(
    settings.path,
    settings.location,
    settings.locationSettings
  );
  if (!organizationId) {
    return newDestination;
  }
  const search = new URLSearchParams(newDestination.search);
  if (!search.has(organizationQueryKey)) {
    search.set(organizationQueryKey, organizationId);
    newDestination.search = search.toString();
  }
  return newDestination;
};

export const isRowSelectable = (member: Member): boolean =>
  member?.email !== getUser()?.email && !member?.inactive && !member?.ssoSynced;
